import common from '@cloudpivot/common';
export default common.directives.transferDom;
